/**
 * @desc 接口配置
 * @created: 2020/4/6
 * @author:lijun
 * @version : v1.0
 */
import request from '@/plugins/http'

// 列表查询
export const getListData = (params) => {
  return request.get('/servicerConfig/list', params)
}

// 查看详情
export const getDetails = params => {
  return request.get('/servicer/details', params)
}

// 配置查询
export const configDetails = (params) => {
  return request.get('/servicerConfig/details', params)
}

// 添加子账号-添加用户
export const createUser = (data) => {
  return request.post('/servicerConfig/createuser', data, { json: true })
}
// 配置
export const postConfig = (data) => {
  return request.post('/servicerConfig/config', data, { json: true })
}
